import { FIELD_DOCUMENTATION_URLS } from "../constants.js";
import { addLine } from "./addLine.js";
import { getAPIIDPath } from "./getAPIIDPath.js";
import { getHumanReadableModelName } from "./getHumanReadableModelName.js";
import { getHumanReadablePath } from "./getHumanReadablePath.js";
function getHumanReadableFieldType(args) {
  var _a, _b;
  switch (args.field.type) {
    case "StructuredText": {
      return "Rich Text";
    }
    case "IntegrationFields": {
      const catalog = (_a = args.field.config) == null ? void 0 : _a.catalog;
      return `Integration Fields (Catalog: ${catalog ? `\`${catalog}\`` : "*unknown*"})`;
    }
    case "Link": {
      switch ((_b = args.field.config) == null ? void 0 : _b.select) {
        case "document": {
          return "Content Relationship";
        }
        case "media": {
          return "Link to Media";
        }
        default: {
          return "Link";
        }
      }
    }
    case "Slices": {
      return "Slice Zone";
    }
    default: {
      return args.field.type;
    }
  }
}
function getDocumentationURL(args) {
  var _a;
  switch (args.field.type) {
    case "Link": {
      const urls = FIELD_DOCUMENTATION_URLS.Link;
      switch ((_a = args.field.config) == null ? void 0 : _a.select) {
        case "document": {
          return urls.contentRelationship;
        }
        case "media": {
          return urls.linkToMedia;
        }
        default: {
          return urls.link;
        }
      }
    }
    default: {
      const url = FIELD_DOCUMENTATION_URLS[args.field.type];
      if (typeof url === "string") {
        return url;
      }
    }
  }
}
function buildFieldDocs(args) {
  let result = "/**";
  const humanReadableName = getHumanReadableModelName({
    model: args.field,
    name: args.name
  });
  const humanReadablePath = getHumanReadablePath({ path: args.path });
  const humanReadableFieldType = getHumanReadableFieldType({
    field: args.field
  });
  result = addLine(` * ${humanReadableName} field in *${humanReadablePath}*`, result);
  result = addLine(" *", result);
  result = addLine(` * - **Field Type**: ${humanReadableFieldType}`, result);
  const placeholder = args.field.config && "placeholder" in args.field.config && args.field.config.placeholder || `*None*`;
  result = addLine(` * - **Placeholder**: ${placeholder}`, result);
  const defaultValue = args.field.config && "default_value" in args.field.config ? args.field.config.default_value : void 0;
  if (defaultValue !== void 0) {
    const stringifiedDefaultValue = typeof defaultValue === "boolean" ? `${defaultValue}` : defaultValue;
    result = addLine(` * - **Default Value**: ${stringifiedDefaultValue}`, result);
  }
  const apiIDPath = getAPIIDPath({
    path: [...args.path, { name: args.name, model: args.field }]
  });
  result = addLine(` * - **API ID Path**: ${apiIDPath}`, result);
  if (args.tabName) {
    result = addLine(` * - **Tab**: ${args.tabName}`, result);
  }
  const documentationURL = getDocumentationURL({ field: args.field });
  if (documentationURL) {
    result = addLine(` * - **Documentation**: ${documentationURL}`, result);
  }
  result = addLine(" */", result);
  return result;
}
export {
  buildFieldDocs
};
//# sourceMappingURL=buildFieldDocs.js.map
